import styled from 'styled-components';
import { getRgbaValue, rem } from '../../utils/style';
import { COLORS } from '../../constants/style/color';

export const PreviewContainer = styled.div`
  border: 1px solid #e0e0e0;
  padding: 12px;
  min-height: ${rem(495)};
  max-height: ${rem(495)};
  overflow-y: auto;
  font-size: ${rem(16)};
  ul {
    list-style: disc;
    padding-left: 2em;
  }
  ol {
    list-style: decimal;
    padding-left: 2em;
  }
`;

export const EditorContainer = styled.div`
  .rsw-ce ul {
    list-style: disc;
    padding-left: 2em;
  }

  .rsw-ce ol {
    list-style: decimal;
    padding-left: 2em;
  }
  .rsw-toolbar,
  .rsw-separator {
    background: none;
    border: none;
  }
  .rsw-toolbar {
    padding: ${rem(4)};
  }
  .rsw-editor {
    border-radius: ${rem(0)};
    min-height: ${rem(495)};
    max-height: ${rem(495)};
    overflow-y: auto;
  }
  .toolbar-custom {
    margin-top: 0 !important;
  }

  .rdw-option-active {
    background-color: ${COLORS.Purple};
    border-color: ${COLORS.Purple};
    box-shadow: 1px 1px 0px ${COLORS.Purple} inset;
    img {
      filter: invert(1);
    }
  }

  .rsw-btn {
    background: ${COLORS.White};
    border: ${rem(1)} solid ${COLORS.LightGray};
    padding: ${rem(4)};
    color: ${COLORS.Gray};
    border-radius: ${rem(6)};
    font-weight: 500;
    font-size: ${rem(14)};
    line-height: ${rem(16)};
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease-in-out;
    margin: 0 ${rem(2)};

    &:hover {
      border: ${rem(1)} solid ${COLORS.SpanishGray};
      box-shadow: ${rem(0)} ${rem(4)} ${rem(6)} ${getRgbaValue(`${COLORS.Gray100}`, 0.24)};
    }

    &:active {
      color: ${COLORS.Black};
      border: ${rem(1)} solid ${COLORS.SpanishGray};
    }

    &[data-active='true'] {
      background-color: ${COLORS.LightPurple};
      color: ${COLORS.Purple};
      border-color: ${COLORS.Purple};
    }
  }

  // .public-DraftStyleDefault-block {
  //   margin: 0;
  // }
`;

export const QuillEditorContainer = styled.div`
  .ql-editor {
    min-height: 80px !important;
    font-size: 16px !important;
    padding: 16px !important;
  }
  .ql-toolbar {
    border-bottom: 1px solid #ccc !important;
  }
  .ql-container {
    border-top: none !important;
  }
  .ql-editor p {
    margin: 1em 0px !important;
  }
  .ql-editor li {
    margin: 1em 0px !important;
  }
`;
